// Site-wide constants. The resume PDF is generated from the /resume page (see src/data/resume.js).
export const RESUME_PATH = '/downloads/Maurice-Sanders-Resume.pdf';
export const RESUME_DOWNLOAD_NAME = 'Maurice-Sanders-Resume.pdf';
export const RESUME_PAGE = '/resume';

export const SITE_NAME = 'Maurice Sanders';
export const GITHUB_URL = 'https://github.com/MrAfroTech';

export const DEFAULT_TITLE = 'Maurice Sanders | Portfolio';
export const DEFAULT_DESCRIPTION =
  'The proof: a production 0DTE options trading platform, a live ticketing platform that earns a fee on every ticket sold, and an AI concierge that plans a whole night out. I write the specs, make the architecture calls, and direct AI coding agents from first prompt to production, so a team of one ships like a team of ten.';
